<app-resource-table-base
    #tableBase
    *ngIf="user"
    [columnsData]="columnsData"
    [columnsKeys]="columnsKeys"
    [expandedRowId]="expandedRowId"
    [expandedFn]="expandedFn"
    (expansionToggled)="expansionToggled($event)"
    [otherContext]="otherContext"
    [expandingTable]="true"
    [canSelect]="false"
    [filter]="filter"
    [tableFilterItems]="tableFilterItems"
>
    <ng-container tableFiltersTempl>
        <app-table-filter
            [filtersTogglesInOnBtn]="true"
            [defaultFilter]="GlobalFilterProperty.SEARCH"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="Schema"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>

            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Type"
                i18n-label="@@type"
                [property]="{
                    name: GlobalFilterProperty.SCOPE,
                    type: GlobalFilterPropertyType.RESOURCE_TYPE
                }"
                [options]="resourceTypeOptions"
                scopesFilterRef
            >
            </app-select-filter>
            <app-tag-chip-search-filter
                [inGlobalFilter]="true"
                fxFlex="50%"
                fxFlex.lt-md="100%"
                fxLayoutAlign="start"
                tagsFilterRef
            ></app-tag-chip-search-filter>
        </app-table-filter>
    </ng-container>
</app-resource-table-base>
<ng-template #expansionContextTemplate let-resource>
    <app-instructor-signoffs-users-listing
        *ngIf="expandedFn(resource)"
        [authUser]="user"
        [approvalStatus]="approvalStatusSubject.value"
        [tableFilterItems]="[
            { property: 'eager', items: ['activations'] },
            { property: 'signedoff_resource', items: [resource.id] }
        ]"
        [resource]="resource"
        (onUpdateStatus)="onChangeStatus()"
        class="expansion-context"
    ></app-instructor-signoffs-users-listing>
</ng-template>

<ng-template #img let-resource>
    <app-image-view
        [media_id]="resource.media$"
        [proportional]="true"
        [paddingBottom]="'58px'"
        [smallSpinner]="true"
        [showImgModalOnClick]="true"
    ></app-image-view>
</ng-template>
<ng-template #title let-resource>
    <ng-container *ngIf="!(isMobile$ | async)">
        <span> {{ resource.title }}</span>
        <div class="hover-wrapper">
            <button
                class="hover-tools-btn view"
                mat-icon-button
                matTooltip="View"
                (click)="$event.stopPropagation(); browse(resource)"
                i18n-matTooltip="@@view"
            >
                <mat-icon>visibility</mat-icon>
            </button>
            <button
                class="hover-tools-btn view"
                mat-icon-button
                [matTooltip]="getPlayBtnTxt(resource)"
                (click)="$event.stopPropagation(); !resource.loading && play(resource)"
            >
                <mat-icon>play_circle</mat-icon>
            </button>
            <ng-container *ngIf="customer$ | async; let customer">
                <button
                    *ngIf="resource.user_collaboration?.edit?.status"
                    class="hover-tools-btn view"
                    mat-icon-button
                    matTooltip="Edit"
                    i18n-matTooltip
                    (click)="$event.stopPropagation(); !resource.loading && edit(resource)"
                >
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="resource.last_publish">
                <button
                    class="hover-tools-btn"
                    *ngIf="!(shareLoading | async); else shareLoadTemp"
                    mat-icon-button
                    matTooltip="Share"
                    i18n-matTooltip="@@share"
                    (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
                >
                    <mat-icon>share</mat-icon>
                </button>
            </ng-container>
            <button
                *ngIf="resource.downloads"
                class="hover-tools-btn"
                mat-icon-button
                matTooltip="Download PDF"
                i18n-matTooltip="@@downloadPDF"
                (click)="$event.stopPropagation(); download(resource)"
            >
                <mat-icon>save_alt</mat-icon>
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
        <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
            <app-image-view
                [media_id]="resource.media$"
                [proportional]="true"
                [paddingBottom]="'50px'"
                [smallSpinner]="true"
            ></app-image-view>
            <span class="res-title" fxFlex="grow"> {{ resource.title }}</span>
            <div fxLayout="column" fxLayoutAlign="start start">
                <ng-container *ngIf="canExpand(resource)">
                    <button
                        *ngIf="resource.id as expandId"
                        class="mob-expand-btn"
                        (click)="$event.stopPropagation(); expansionToggled(resource)"
                        mat-icon-button
                    >
                        <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #enrollment_date let-resource>
    <app-occasions-dates-viewer
        *ngIf="getOccasionDates(resource).length"
        [dates]="getOccasionDates(resource)"
        [canShowMore]="true"
        [timeZone]="resource.time_zone"
    ></app-occasions-dates-viewer>
</ng-template>
<ng-template #enrollment let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@Enrollment">Enrollment</span>
    <div
        (click)="approvalStatusSubject.next('enrollment')"
        class="circles-status registered-users"
        matTooltip="Enrollment / Total seats"
        i18n-matTooltip="@@enrollment/totalSeats"
    >
        <span *ngIf="resource.total_seats"> {{ resource.enrollment_counts?.total }}/{{ resource.total_seats }} </span>
        <span *ngIf="!resource.total_seats">
            {{ resource.enrollment_counts?.total }}
        </span>
    </div>
</ng-template>
<ng-template #signoffs let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@signoffs">Signoffs</span>
    <div (click)="approvalStatusSubject.next('signoffs')" class="circles-status registered-users">
        {{ resource.signoff_counts?.total }}
    </div>
</ng-template>

<ng-template #approved_users let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@approved">Approved</span>
    <div
        matTooltip="Display approved"
        i18n-matTooltip="@@displayApproved"
        (click)="resource.signoff_counts?.approved > 0 && approvalStatusSubject.next('approved')"
        class="circles-status approved-users"
    >
        {{ resource.signoff_counts?.approved }}
    </div>
</ng-template>
<ng-template #dismissed_users let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@dismissed">Dismissed</span>
    <div
        matTooltip="Display waiting and rejected users"
        i18n-matTooltip="@@displayRejectedAndWaiting"
        (click)="
            (resource.signoff_counts?.rejected > 0 || resource.signoff_counts?.waiting > 0) &&
                approvalStatusSubject.next('waiting')
        "
        class="circles-status rejected-users"
    >
        {{ resource.signoff_counts?.waiting + resource.signoff_counts?.rejected }}
    </div>
</ng-template>
<ng-template #pending_users let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@pending">Pending</span>
    <div
        matTooltip="Display pending"
        i18n-matTooltip="@@displayPending"
        (click)="resource.signoff_counts?.pending > 0 && approvalStatusSubject.next('pending')"
        class="circles-status waiting-users"
    >
        {{ resource.signoff_counts?.pending }}
    </div>
</ng-template>
<ng-template #type let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@type">Type: </span>
    <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.COURSE"
            fontSet="klickdata"
            [fontIcon]="resource.type_id | typeFontIcon"
            class="kd-icon"
        ></mat-icon>
        <mat-icon class="event-icon" *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.EVENT"
            >event</mat-icon
        >

        <span> {{ ResourceTypes.label(resource.type_id, { capitalize: true }) }}</span>
    </div>
</ng-template>
<ng-template #tools let-resource>
    <div *ngIf="!(isMobile$ | async)" class="tools-cell-wrapper">
        <button
            *ngIf="canExpand(resource)"
            (click)="$event.stopPropagation(); expansionToggled(resource); approvalStatusSubject.next('')"
            matTooltip="View"
            mat-icon-button
            i18n-matTooltip="@@view"
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="isMobile$ | async">
        <button
            class="hover-tools-btn view"
            mat-icon-button
            matTooltip="View"
            (click)="$event.stopPropagation(); browse(resource)"
            i18n-matTooltip="@@view"
        >
            <mat-icon>visibility</mat-icon>
        </button>
        <button
            class="hover-tools-btn view"
            mat-icon-button
            [matTooltip]="getPlayBtnTxt(resource)"
            (click)="$event.stopPropagation(); !resource.loading && play(resource)"
        >
            <mat-icon>play_circle</mat-icon>
        </button>
        <ng-container *ngIf="resource.last_publish">
            <button
                class="hover-tools-btn"
                *ngIf="!(shareLoading | async); else shareLoadTemp"
                mat-icon-button
                matTooltip="Share"
                i18n-matTooltip="@@share"
                (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
            >
                <mat-icon>share</mat-icon>
            </button>
        </ng-container>
        <button
            *ngIf="resource.downloads"
            class="hover-tools-btn"
            mat-icon-button
            matTooltip="Download PDF"
            i18n-matTooltip="@@downloadPDF"
            (click)="$event.stopPropagation(); download(resource)"
        >
            <mat-icon>save_alt</mat-icon>
        </button>

        <button
            *ngIf="!!resource.user_collaboration?.edit?.status"
            (click)="$event.stopPropagation(); edit(resource)"
            mat-icon-button
        >
            <mat-icon>edit</mat-icon>
        </button>
        <button
            *ngIf="canExpand(resource)"
            (click)="$event.stopPropagation(); expansionToggled(resource); approvalStatusSubject.next('')"
            mat-icon-button
            class="expand-btn"
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
